import { render, staticRenderFns } from "./PayingScbEasy_backup_new.vue?vue&type=template&id=4554f7f0"
import script from "./PayingScbEasy_backup_new.vue?vue&type=script&lang=js"
export * from "./PayingScbEasy_backup_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports